export const qrConstants = {
    QR_UID_REQUEST: 'QR_UID_REQUEST',
    QR_UID_SUCCESS: 'QR_UID_SUCCESS',
    QR_UID_FAILURE: 'QR_UID_FAILURE',

    QR_DATA_REQUEST: 'QR_DATA_REQUEST',
    QR_DATA_SUCCESS: 'QR_DATA_SUCCESS',
    QR_DATA_FAILURE: 'QR_DATA_FAILURE',

    QR_FILE_REQUEST: 'QR_FILE_REQUEST',
    QR_FILE_SUCCESS: 'QR_FILE_SUCCESS',
    QR_FILE_FAILURE: 'QR_FILE_FAILURE',
  }
  